import { render, staticRenderFns } from "./BriqCountrySelect.vue?vue&type=template&id=1d47493f&lang=pug&"
import script from "./BriqCountrySelect.vue?vue&type=script&lang=js&"
export * from "./BriqCountrySelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports